import React, { useState, useEffect } from 'react';
import { Card, Avatar, Descriptions, Button, Space, Spin, message } from 'antd';
import { UserOutlined, EditOutlined } from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import * as authService from '../../services/auth/authService';
import './index.css';

const Profile = () => {
  const { user } = useAuth();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [userProfile, setUserProfile] = useState(null);

  useEffect(() => {
    loadUserProfile();
  }, []);

  const loadUserProfile = async () => {
    try {
      setLoading(true);
      const response = await authService.getUserProfile();
      if (response.success) {
        setUserProfile(response.data);
      } else {
        message.error(response.message);
      }
    } catch (error) {
      console.error('加载用户信息失败:', error);
      message.error('加载用户信息失败');
    } finally {
      setLoading(false);
    }
  };

  const displayUser = userProfile || user;

  return (
    <div className="profile-page">
      <h2>{t('user.profile')}</h2>
      <Spin spinning={loading}>
        <Card className="profile-card">
          <div className="profile-header">
            <Avatar 
              size={80} 
              src={displayUser?.avatar} 
              icon={<UserOutlined />}
            />
            <div className="user-info">
              <h3>{displayUser?.name}</h3>
            </div>
          </div>
          
          <Descriptions column={1} bordered>
            <Descriptions.Item label="Username(Login Account)">
              {displayUser?.loginId}
            </Descriptions.Item>
            <Descriptions.Item label="Name">
              {displayUser?.name}
            </Descriptions.Item>
            <Descriptions.Item label="Email">
              {displayUser?.email}
            </Descriptions.Item>
            {/* <Descriptions.Item label="电话">
              {displayUser?.mobile}
            </Descriptions.Item> */}
            <Descriptions.Item label="Division">
              {displayUser?.orgName}
            </Descriptions.Item>
          </Descriptions>
          
          {/* <div className="profile-actions">
            <Space>
              <Button type="primary" icon={<EditOutlined />}>
                编辑资料
              </Button>
              <Button>
                修改密码
              </Button>
            </Space>
          </div> */}
        </Card>
      </Spin>
    </div>
  );
};

export default Profile; 